import Prefernces from '../components/student/preference'
import '../components/test.css'
import Navbar from "../components/Navbar/stunavbar"
import '../components/Navbar/navbar.css'

function Addprefer() {


  return (
    <div className='newAdmin'>   
      <Navbar/>
      <Prefernces/>
    </div>
  )
}

export default Addprefer
